.filterBar :global(.input-group) {
  width: auto;
}
